import p from './product'
import r from './release'

export default{
    product:p,
    release:r
}